<template>
  <div class="main_wrap unit">
    <div class="myMenu" style="position:unset;margin: 20px auto;">
        <div @click="goWorkPlat">执法管理</div>
        <!-- <div v-if="handle_pool" @click="poolList">警情池</div>
        <div @click="goReceive">接警记录</div>
        <div @click="reportList">举报管理</div> -->
        <div @click="personList" v-if="command=='超级管理员' || command=='高级管理员'">人员管理</div>
        <div v-if="command=='超级管理员' || command=='高级管理员'" class="priority">单位管理</div>
        <!-- <div v-if="command=='超级管理员'||command=='高级管理员'" @click="examineList">我的审批</div> -->
    </div>
    <div class="search-box">
      <form @submit.prevent="getUnitList">
        <div class="select-wrap">
          <div class="group margin-right-15">
            <span class="left">单位名称</span>
            <div class="right">
              <input
                type="text"
                placeholder="请输入单位名称"
                v-model.trim="model.organizationName"
              />
            </div>
          </div>
          <div class="group situation margin-right-15 searchArrow">
            <span class="left">所属区域</span>
            <div class="right">
              <el-select
                placeholder="全部"
                class=""
                v-model="provinceData.currentProvinceName"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                placeholder="全部"
                class=""
                v-model="provinceData.currentCityName"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select placeholder="全部" class="" v-model="model.areaId">
                <el-option :key="null" :label="'全部'" :value="null">
                </el-option>
                <el-option
                  v-for="item in areaData"
                  :key="item.id"
                  :label="item.areaName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="group btn-box">
            <button type="submit" class="btn margin-left-0">搜索</button>
            <button type="button" @click="detailBox" class="btn">新增</button>
            <button type="button" @click="deleteConfirm(deleteId)" class="btn">
              删除
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="table_wrap">
      <div class="table_layout">
        <div class="table_scroll">
          <el-table
            :data="dataTabel"
            max-height="534"
            border
            :cell-style="cellStyle"
            style="width: 100%"
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="60"> </el-table-column>
            <el-table-column
              label="单位名称"
              prop="fullName"
              min-width="100"
              key="1"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="简称"
              prop="simpName"
              min-width="100"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="组织机构代码"
              prop="organizationCode"
              min-width="100"
              key="2"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="所属区域"
              min-width="120"
              key="3"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ provinceData.currentProvinceName
                }}{{ provinceData.currentCityName
                }}<span v-if="scope.row.areaName">{{
                  scope.row.areaName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="排序号"
              prop="indexNo"
              min-width="80"
              key="4"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="100"
              key="9"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  @click="editUnitData(scope.row.id)"
                  class="primary pointer mr15"
                  >修改</span
                >
                <span
                  @click="deleteConfirm(scope.row.id)"
                  class="primary pointer mr15"
                  >删除</span
                >
                <span class="primary pointer mr15" @click="staffLink"
                  >人员管理</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      
        <div class="pagination" v-if="dataTabel.length">
          <nt-pagination ref="child" @fetchData="getUnitList"></nt-pagination>
        </div>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <detail
        v-if="detailShow"
        @detailShowData="detailShowData"
        @getUnitList="getUnitList"
        :unitData="unitData"
      ></detail>
    </transition>
  </div>
</template>

<script>
import config from "@/common/env"
import detail from './detail'
import { mapState } from 'vuex'

export default {
  name: "list",
  components: {
    detail
  },
  data () {
    return {
      model: {
        organizationName: null,
        areaId: null,
        pageSize: 10,                 //每页记录数
        pageNo: 1,                   //页码
      },
      dataList: [{}],
      editShow: false,//新增-编辑弹层显示字段
      projectList: [],
      detailShow: false,
      dataTabel: [],
      areaData: [],
      provinceData: {
        // currentProvinceId: "210000",
        // currentProvinceName: "辽宁省",
        // currentCityId: "024",
        // currentCityName: "沈阳市"
      },
      multipleSelection: [],
      deleteId: [],
      listIdex: [],
      idsVal: {
        ids: null
      },
      unitData: {},

      handle_pool: config.handle_pool,

    }
  },
  computed: {
    crumbList () {
      console.log(this.$route.meta.crumbList)
      return this.$route.meta.crumbList
    },
    ...mapState(['userInfo','command']),
    roleAuthority () {
      let authority = this.$store.state.userAuth.filter(item => item.routingKey == 'roleAdmin')
      console.log(authority)
      if (authority.length) {
        let arr = authority[0]['button']
        return arr
      } else {
        return []
      }
    },
    authInfos () {
      var authInfos = localStorage.getItem('authInfo')
      var authInfo = JSON.parse(authInfos)
      var authInfoArray = authInfo.buttons.split(',')
      if (authInfoArray.length) {
        return authInfoArray
      }
    }
  },
  watch: {
    command(newV) {
      console.log(newV)
      if(newV != "超级管理员" || newV != "高级管理员") {
        this.goWorkPlat()
      }
    },
  },
  mounted () {
    // this.fetchData()
    this.getAreaList()
    this.getUnitList()
    this.currentProvince()
  },
  methods: {
    examineList() {
          this.$router.push('/examine');
        },
    goWorkPlat() {
            this.$router.push('/workPlat');
            // window.open('/workPlat', this.getWindowName('workPlat')).focus();
        },
        goReceive() {
            this.$router.push('/receive');
        },
        
        personList() {
            this.$router.push('/staff');

        },
    closeMask () {
      this.detailShow = false
    },
    dateChange (data) {
      this.model.createTimeStart = data.from
      this.model.createTimeEnd = data.to
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      return 'height:20px;font-size:12px'
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f4f5f7;height:40px;color:#4a4a4a!important;font-size:13px'
      }
    },
    createRole (val) {
      console.log(val)
      this.editShow = true
      if (val.id) {
        console.log(val)
        this.sendData = val
      } else {
        this.sendData = {}
      }
    },
    hideEditMask () {
      this.editShow = false
    },
    groupingMask (projectId) {
      this.getRoleList(projectId)
    },
    getRoleList (id) {
      this.$axios.post('/rm-user-manage/api/admin/meun/findCheckedRole/' + id).then(res => {
        let data = this.AppUtils.checkResponse(res)
        if (data) {
          console.log(data)
          this.roleList = data.data
          console.log(this.roleList.list)
          if (this.roleList.list.length) {
            this.checkedRole = []
            this.checkedRole.push(this.roleList.list[0]['id'])
          }
          this.resourceShow = true
          // this.checkedRole=
        }
      })
    },
    hideGroupingMask () {
      this.resourceShow = false
    },
    fetchData (args) {
      // 初始化分页
      this.model.pageNo = 1
      this.model.pageSize = 10
      if (args) {
        if (args.page) {//分页
          this.model.pageNo = args.page//当前页数
          this.model.pageSize = args.pageSize//每页显示多少条
        }
      }
      this.$axios.post('/rm-user-manage/api/admin/role/list', this.model).then(res => {
        let data = this.AppUtils.checkResponse(res)
        if (data) {
          this.dataList = data.data.dataList
          if (this.dataList.length) {
            console.log(this.projectList)
            for (let i in this.dataList) {
              console.log(this.dataList[i].projectId)
              for (let j in this.projectList) {
                if (this.projectList[j].id == this.dataList[i].projectId) {
                  this.dataList[i].projectName = this.projectList[j].label
                }
              }
            }
            this.$nextTick(() => {
              this.$refs.child.initPage(data.data.totalNum, this.model.pageNo, this.model.pageSize)
            })
          }
        }
      })
    },
    submit () {
      this.$router.replace(`${this.$route.path}?searchInfo=${JSON.stringify(this.model)}`)
      this.fetchData()
    },
    // 新增浮层展开
    detailBox () {
      this.detailShow = true
      // 重置详情页数据
      this.unitData = {
        accidentNoPrefix: null,
        cityId: null,
        cityName: null,
        areaId: 0,
        areaName: null,
        createId: null,
        createTime: null,
        desc: null,
        fullName: null,
        id: null,
        indexNo: null,
        organizationCode: null,
        provinceId: null,
        provinceName: null,
        simpName: null,
        stampUrl: null,
        isNew: true
      }
    },
    detailShowData (val) {
      this.detailShow = val
    },
    // 获取搜索列表
    getUnitList (args) {
      // 初始化分页
      this.model.page = 1
      this.model.size = 10
      if (args) {
        if (args.page) {//分页
          this.model.page = args.page//当前页数
          this.model.size = args.pageSize//每页显示多少条
        }
      }
      this.$axios.post('/admin/organization/list', this.model).then(res => {
        let data = this.AppUtils.checkResponse(res)
        if (data) {
          this.dataTabel = data.data.list
          // this.$message.success(data.msg)
          // 向分页组件传送数据
          this.$nextTick(() => {
            this.$refs.child.initPage(data.data.total, this.model.page, this.model.size)
          })
        }
      })
    },
    // 获取省市区三联数据
    currentProvince () {
      this.$axios.get('/admin/location/currentProvince').then(res => {
        let data = this.AppUtils.checkResponse(res)
        if (data) {
          this.provinceData = data.data
        }
      })
    },
    getAreaList () {
      this.$axios.get('/admin/organization/areaList').then(res => {
        let data = this.AppUtils.checkResponse(res)
        if (data) {
          this.areaData = data.data
        }
      })
    },
    // 获取选中表格id
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.deleteId = this.multipleSelection.map((item) => item.id)
    },
    // 修改
    editUnitData (val) {
      this.$axios.get('/admin/organization/detail/' + val).then(res => {
        let data = this.AppUtils.checkResponse(res)
        if (data) {
          this.unitData = data.data
          this.detailShow = true
          this.unitData.isNew = false
          this.unitData.id = val
          // this.$message.success(data.msg)
        }
      })
    },
    // 删除条目
    deleteConfirm (val) {
      if (val.length <= 0) {
        this.$message.error("请选中需要删除的数据")
        return
      }
      if (Array.isArray(val)) {
        this.idsVal.ids = val.join(",")
      } else {
        this.idsVal.ids = val
      }
      this.AppUtils.confirm('是否确认删除选中的数据？', () => {
        this.$axios.post('/admin/organization/delete', this.idsVal).then(res => {
          let data = this.AppUtils.checkResponse(res)
          if (data) {
            // this.areaData = data.data
            if (Array.isArray(val)) {
              this.multipleSelection.forEach((value, index) => {
                //遍历多选框获取的数据
                this.dataTabel.forEach((v, i) => {
                  //遍历数据表，任意一个属性值相同，则说明该数据被选中，其i则为索引值
                  if (value.id == v.id) {
                    this.dataTabel.splice(i, 1)
                  }
                })
              })

            } else {
              this.dataTabel.forEach((v, i) => {
                //遍历数据表，任意一个属性值相同，则说明该数据被选中，其i则为索引值
                if (val == v.id) {
                  this.dataTabel.splice(i, 1)
                }
              })
            }
            this.getUnitList()
            this.$message.success("删除成功")
          }
        })
      }, () => {
        // 取消删除
      })
    },
    // 跳转到人员管理
    staffLink () {
      this.$router.push('/staff')
    }
  }
}
</script>

<style scoped lang="scss">
.mr15 {
  margin-right: 15px;
}

.select-wrap {
  padding-left: 20px;

  .date-box {
    width: 346px;
  }

  & > .group {
    margin-right: 50px;

    span.left {
      width: auto;
    }

    .el_box {
      width: 110px;
    }
  }

  .area {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?16c609e2